import type { PrintTemplateDocument } from '#shared/types';

/**
 * The builder's sections, in the order they are listed. Signatures sits
 * between the results table and the footer because that is where it prints.
 */
export const TEMPLATE_SECTIONS = [
  { id: 'page', title: 'Paper' },
  { id: 'theme', title: 'Type and colour' },
  { id: 'header', title: 'Letterhead' },
  { id: 'body', title: 'Results table' },
  { id: 'signatures', title: 'Signatures' },
  { id: 'footer', title: 'Footer' },
  { id: 'watermark', title: 'Watermark' },
] as const;

export type TemplateSectionId = (typeof TEMPLATE_SECTIONS)[number]['id'];

function countEnabled(items: readonly { enabled: boolean }[]): number {
  return items.filter((item) => item.enabled).length;
}

/** The one-line summary shown on a closed section's header. */
export function sectionSubtitle(id: TemplateSectionId, document: PrintTemplateDocument): string {
  switch (id) {
    case 'page':
      return `${document.page.size} · ${document.page.orientation}`;
    case 'theme':
      return `${document.theme.font} · ${document.theme.base_size}pt`;
    case 'header':
      return document.header.enabled
        ? `${document.header.layout} · ${countEnabled(document.header.patient_fields)} details`
        : 'Off';
    case 'body':
      return `${countEnabled(document.body.columns)} columns`;
    case 'signatures':
      return document.signatures.enabled
        ? `${countEnabled(document.signatures.blocks)} blocks`
        : 'Off';
    case 'footer':
      return document.footer.enabled ? `${document.footer.columns.length} blocks` : 'Off';
    case 'watermark':
      return document.watermark.enabled ? document.watermark.text || 'Blank' : 'Off';
  }
}
